module.exports = __webpack_public_path__ + "static/media/deca_logo.baf30308.svg";